import type { TenantPublicDto } from '../../api/tenant-public.service';
import type { PublicTenantListItem } from '../../api/tenants-public-list.service';
import { route, type HandlerEntry } from '../handler-registry';

const DEMO_AFFILIATES: readonly PublicTenantListItem[] = [
  {
    tenantId: 'aff-karate-fenix',
    subdomain: 'fenix-karate',
    teamName: 'Fenix Karate Club',
    discipline: 'Karate',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Tradiție Shotokan din 1998 — sportivi de toate vârstele.',
    city: 'București',
    studentCount: 124,
    contact: {
      email: 'contact@fenix-karate.ro',
      phone: '+40 721 000 001',
      whatsapp: '+40 721 000 001',
    },
  },
  {
    tenantId: 'aff-karate-shotokan',
    subdomain: 'shotokan-cluj',
    teamName: 'Shotokan Cluj',
    discipline: 'Karate',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Cursuri pentru copii și juniori, antrenori cu centură neagră.',
    city: 'Cluj-Napoca',
    studentCount: 86,
    contact: { email: 'salut@shotokan-cluj.ro', phone: '+40 264 555 222', whatsapp: null },
  },
  {
    tenantId: 'aff-judo-samurai',
    subdomain: 'samurai-judo',
    teamName: 'Samurai Judo',
    discipline: 'Judo',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Judo pentru copii și adulți. Sală dotată, tatami profesional.',
    city: 'Timișoara',
    studentCount: 64,
    contact: { email: 'info@samurai-judo.ro', phone: '+40 256 123 456', whatsapp: '+40 256 123 456' },
  },
  {
    tenantId: 'aff-swim-dolphin',
    subdomain: 'dolphin-swim',
    teamName: 'Dolphin Swim Academy',
    discipline: 'Swimming',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Învățăm copiii să înoate sigur. Trei piscine la dispoziție.',
    city: 'București',
    studentCount: 210,
    contact: { email: 'office@dolphinswim.ro', phone: '+40 722 333 444', whatsapp: null },
  },
  {
    tenantId: 'aff-swim-blue',
    subdomain: 'blue-water',
    teamName: 'Blue Water Constanța',
    discipline: 'Swimming',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Înot de performanță și recreativ pe litoral.',
    city: 'Constanța',
    studentCount: 92,
    contact: { email: null, phone: '+40 241 778 899', whatsapp: '+40 723 778 899' },
  },
  {
    tenantId: 'aff-foot-tigers',
    subdomain: 'tigers-fc',
    teamName: 'Tigers FC',
    discipline: 'Football',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Academia de fotbal pentru copii 5-14 ani.',
    city: 'București',
    studentCount: 312,
    contact: { email: 'office@tigersfc.ro', phone: '+40 728 000 111', whatsapp: null },
  },
  {
    tenantId: 'aff-foot-eagles',
    subdomain: 'eagles-iasi',
    teamName: 'Eagles Iași',
    discipline: 'Football',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Antrenori UEFA B, terenuri cu gazon natural.',
    city: 'Iași',
    studentCount: 168,
    contact: { email: 'salut@eaglesiasi.ro', phone: '+40 232 111 222', whatsapp: '+40 723 111 222' },
  },
  {
    tenantId: 'aff-gym-flex',
    subdomain: 'flex-gym',
    teamName: 'Flex Gimnastică',
    discipline: 'Gymnastics',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Gimnastică artistică și acrobatică pentru copii.',
    city: 'Brașov',
    studentCount: 78,
    contact: { email: 'contact@flexgim.ro', phone: '+40 268 200 300', whatsapp: null },
  },
  {
    tenantId: 'aff-tennis-ace',
    subdomain: 'ace-tennis',
    teamName: 'Ace Tennis Academy',
    discipline: 'Tennis',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Cursuri individuale și de grup, terenuri zgură și hardcourt.',
    city: 'București',
    studentCount: 145,
    contact: { email: 'play@acetennis.ro', phone: '+40 727 555 666', whatsapp: '+40 727 555 666' },
  },
  {
    tenantId: 'aff-pt-alex',
    subdomain: 'alex-fitness',
    teamName: 'Alex Popescu — Personal Training',
    discipline: 'PersonalTraining',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Antrenamente personalizate, programe de slăbire și forță.',
    city: 'București',
    studentCount: 18,
    contact: { email: 'alex@apt.ro', phone: '+40 724 111 222', whatsapp: '+40 724 111 222' },
  },
  {
    tenantId: 'aff-pt-maria',
    subdomain: 'maria-fitstudio',
    teamName: 'Maria Ionescu Fit Studio',
    discipline: 'PersonalTraining',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Antrenor cu 10 ani experiență, focus pe pilates și mobilitate.',
    city: 'Cluj-Napoca',
    studentCount: 24,
    contact: { email: null, phone: null, whatsapp: '+40 729 333 444' },
  },
  {
    tenantId: 'aff-mma-warriors',
    subdomain: 'warriors-mma',
    teamName: 'Warriors MMA',
    discipline: 'MartialArtsOther',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Box, kickboxing, BJJ — săli moderne, vestiare separate.',
    city: 'București',
    studentCount: 142,
    contact: { email: 'office@warriorsmma.ro', phone: '+40 723 999 888', whatsapp: null },
  },
  {
    tenantId: 'aff-volley-blue',
    subdomain: 'blue-volley',
    teamName: 'Blue Wave Volei',
    discipline: 'TeamSportsOther',
    logoUrl: null,
    coverPhotoUrl: null,
    tagline: 'Volei pentru copii și juniori, antrenamente de 2 ori pe săptămână.',
    city: 'Timișoara',
    studentCount: 56,
    contact: { email: 'info@bluevolei.ro', phone: '+40 256 444 555', whatsapp: null },
  },
];

export const tenantPublicHandlers: readonly HandlerEntry[] = [
  route('GET', /^\/api\/tenants\/[^/]+\/public$/, (_ctx, data) => {
    return data.tenant.public satisfies TenantPublicDto;
  }),
  route('GET', /^\/api\/tenants\/public$/, (ctx) => {
    const discipline = ctx.query.get('discipline');
    const city = ctx.query.get('city');
    const limitRaw = ctx.query.get('limit');
    const limit = limitRaw ? Number(limitRaw) : undefined;
    let result: readonly PublicTenantListItem[] = DEMO_AFFILIATES;
    if (discipline) {
      result = result.filter((t) => t.discipline === discipline);
    }
    if (city) {
      const c = city.toLowerCase();
      result = result.filter((t) => (t.city ?? '').toLowerCase() === c);
    }
    if (limit && Number.isFinite(limit) && limit > 0) {
      result = result.slice(0, limit);
    }
    return result;
  }),
];
